var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 73,
    viewBox: "0 0 43 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4145 70.9912C11.5114 68.7377 11.4779 65.0387 15.3693 62.7771C19.1665 60.5707 25.3628 60.5707 29.1863 62.7771C33.0485 65.0081 33.157 68.7091 29.2305 70.9912C25.433 73.1972 19.2328 73.1959 15.4145 70.9912ZM15.5526 63.0939C11.9186 65.2051 11.928 68.5544 15.5978 70.6737C19.316 72.8202 25.3491 72.8225 29.0462 70.6737C32.6871 68.556 32.665 65.209 29.002 63.0939C25.2887 60.9516 19.262 60.9402 15.5526 63.0939Z",
    fill: "#4C77FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4606 66.8859C28.4662 64.9097 25.7049 63.3 22.2932 63.2905C18.8816 63.2809 16.1114 64.8752 16.1058 66.8513C16.1003 68.8275 18.8615 70.4372 22.2732 70.4467C25.6849 70.4563 28.4551 68.862 28.4606 66.8859Z",
    fill: "#4C77FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8661 20.6391C34.896 27.2523 30.2486 35.2659 24.4993 38.6025C21.6393 40.2408 19.0177 40.4196 17.1412 39.3175L11.0938 35.8024C12.9706 36.9048 15.5919 36.7556 18.4518 35.0875C24.2016 31.7511 28.8486 23.7375 28.8486 17.124C28.8187 13.8471 27.6568 11.5533 25.8099 10.4808L31.8573 13.9959C33.7043 15.0681 34.8661 17.3622 34.8661 20.6391Z",
    fill: "#DE4351"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.166 1.21429L37.2099 4.72646C33.9408 2.82657 29.4147 3.08915 24.4176 5.9744L18.3738 2.46224C23.3708 -0.42302 27.897 -0.685601 31.166 1.21429Z",
    fill: "#CE3E50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.595 69.0745L18.5512 65.5623C17.6503 64.5292 0.532759 44.8992 0.500585 33.481C0.468411 22.0943 8.46281 8.18409 18.3724 2.46265L24.4162 5.97481C14.5067 11.6963 6.51222 25.6062 6.54439 36.9931C6.57689 48.4113 23.6941 68.0413 24.595 69.0745Z",
    fill: "#DE4351"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4236 5.96371C14.5078 11.7034 6.52121 25.6002 6.54559 36.9814C6.56996 48.4116 23.6907 68.0478 24.5945 69.0738C25.4983 66.9977 42.4966 27.6763 42.4479 16.2461C42.4235 4.86492 34.3637 0.24877 24.4236 5.96371ZM24.4967 38.5933C18.7818 41.8903 14.1169 39.2284 14.0925 32.634C14.0681 26.064 18.7083 18.0286 24.448 14.7072C30.1873 11.4102 34.8522 14.0722 34.8766 20.6422C34.901 27.2365 30.2607 35.2716 24.4967 38.5933Z",
    fill: "#F1565D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54481 36.993C6.33065 27.1481 11.6358 14.3912 21.4859 7.27657C24.5782 5.05689 28.2879 3.41731 32.1374 3.51156C28.3052 3.65878 24.7569 5.4043 21.7228 7.60513C13.6182 13.6844 7.01735 25.4289 6.54481 36.993Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8725 20.594C35.2745 27.2082 30.4536 35.5867 24.4933 38.603C29.9742 34.899 34.4682 26.9342 34.8725 20.594Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.85a9a0ce50ab2e691b0d926d2d7ac348.svg";
export { ForwardRef as ReactComponent };